import { render, staticRenderFns } from "./OurStatsEntry.vue?vue&type=template&id=366706ff&scoped=true"
import script from "./OurStatsEntry.vue?vue&type=script&lang=js"
export * from "./OurStatsEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366706ff",
  null
  
)

export default component.exports